<template>
    <div>
        <div class="h-screen flex items-center" v-if="loadingStatus">
            <div class="m-auto">
                <Ripple :isLoading="loadingStatus" />
            </div>
        </div>

        <div v-else class="bg-white lg:mx-60">
            <div v-if="activeTab == 0">
                <div class="flex justify-between items-center mb-14 mx-4 md:px-4 pt-4">
                    <img src="../../assets/images/sycamore_logo.svg" class="w-28 md:w-56">
                    <div>
                        <span class="text-black text-xs md:text-sm">
                            Offer letter {{ investment ? investment.contract_status : '' }}
                        </span>
                        <p class="text-xs md:text-sm">RC : 1903356</p>
                    </div>
                </div>

                <div class="md:w-10/12 m-auto">
                    <div class="mt-12 px-4 lg:px-12">
                        <div class="flex flex-col text-xs md:text-sm mb-5">
                            <div class="mb-6">
                                <p>
                                    {{moment(investment.start_date).format('DD MMMM YYYY')}}.
                                </p>
                                <p>
                                    Policy No.
                                    <span>– {{ investment.investment_id || 'No policy number' }}</span>
                                </p>
                                <p class="font-bold">
                                    Dear {{ investment.Customer ? investment.Customer.name : 'No name' }}
                                </p>
                            </div>

                            <div class="space-y-3">
                                <p class="font-semibold">RE: Investment Agreement with Sycamore  Investment and Asset andManagement Limited</p>
                                
                                <p v-if="investment.start_date">We are pleased to confirm receipt of your funds
                                    with us on the following terms and conditions: </p>
                                <p v-else>We are pleased to offer you this proposed agreement. Kindly review
                                    and confirm if the terms below are acceptable to you. </p>
                            </div>
                        </div>

                        <!-- Table Investment Information -->
                        <div class="mb-6">
                            <table class="text-xs md:text-sm">
                                <thead>
                                    <tr class="">
                                        <th class="border-t-0 border-r-0 border-l-0 border-b-2">
                                            Investment Band</th>
                                        <th
                                            class="border-t-0 border-b-2 border-r-0 border-l-0 font-normal">
                                            {{investment.ProductType? investment.ProductType.name : 'N/A'}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Investment Name</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">{{
                                            investment.name? investment.name : 'N/A'}}</td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Amount Invested</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{ investment.principal_amount?
                                            Number(investment.principal_amount.toFixed(2)).toLocaleString() : 'N/A'}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="bg-transparent border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Value Date</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.start_date? moment(investment.start_date).format('DD MMM YYYY') : 'N/A'}}</td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="bg-transparent border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Maturity Date</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">{{
                                            investment.maturity_date? moment(investment.maturity_date).format('DD MMMM YYYY') : 'N/A'}}</td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Payment Pattern</td>
                                        <td
                                            class="border-t-0 border-b-0 border-r-0 border-l-2 capitalize">
                                            {{investment.interest_payment_type? investment.interest_payment_type:
                                            'N/A'}}</td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Tenor</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{`${investment.tenure} ${investment.tenure_type}`}}</td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Interest Rate (p.a.)</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.interest_rate}}%</td>
                                    </tr>
                                    <tr v-if="interest_payment_types.includes(investment.interest_payment_type)">
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold capitalize">
                                            {{ investment.interest_payment_type }} Interest</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment[`${investment.interest_payment_type}_interest`]).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr v-if="investment.reward_interest">
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Reward Interest</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment.reward_interest).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Gross Interest Accruable</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment.gross_interest).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Withholding Tax</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment.wht_amount).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Net Interest Accruable</td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment.net_interest).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="border-t-0 border-r-0 border-l-0 border-b-0 font-semibold">
                                            Total Payable at Maturity
                                        </td>
                                        <td class="border-t-0 border-b-0 border-r-0 border-l-2">
                                            {{investment.Currency.symbol}}{{Number(investment.total_payable).toLocaleString()}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Terms of Investment -->
                        <div class="mb-6">
                            <ol class="mt-8 text-xs md:text-sm text-justify list-decimal pl-4 flex flex-col gap-2"
                                style="line-height: 1.5rem;">
                                <li>
                                    This agreement is duly governed by laws of the Federal Republic of Nigeria.
                                </li>
                                <li>
                                    Any early liquidation (including part-liquidation) or termination of the contract before the above-stated maturity date shall trigger a 30% penalty charge on the total net interest receivable payment. 
                                </li>
                                <li>
                                    Early liquidation notice should be made at least seven (14) days before the liquidation date.
                                </li>
                                <li>
                                    Please note that funds will be rolled over at the prevailing market rate if not stated before maturity.
                                </li>
                                <li>
                                    That any error observed in the investment certificate will be communicated to the
                                    advisor through mail within three working days of its issue, otherwise the
                                    investment certificate is assumed to be accurate and free from errors.
                                </li>
                                <li>
                                    That any error observed in the investment certificate will be communicated to the advisor through mail within three working days of its issue, otherwise the investment certificate is assumed to be accurate and free from errors.
                                </li>
                            </ol>
                        </div>

                        <!-- Terms and condition -->
                        <div class="mb-6 text-xs md:text-sm text-justify flex flex-col gap-8"
                            style="line-height: 1.5rem;">
                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Terms & Conditions</h1>
                                <p>
                                    Please be advised that <span class="font-semibold">Past performance is no guarantee
                                        of future results</span>
                                    Any person or group of persons who access or rely on this platform or the
                                    information contained herein does so at their own risk, choice and understands the
                                    tool he is about to use.
                                </p>
                                <p>By accessing this platform, you are supposed to read and accept the following terms
                                    and conditions below. These terms and conditions become effective when you click
                                    accept at the bottom of this page.</p>

                                <p>If you do not wish to be bound by these terms and conditions, do not accept the terms
                                    below.
                                </p>
                                <p>For purposes of these terms and conditions, “Client”, “You” and “Your” refers to you,
                                    the person accessing this platform and accepting the Company’s terms and conditions.
                                    “The Company”, “Sycamore”, “We” and “Us”, refers to <span class="font-semibold">Sycamore Investment and Asset
                                    Management Limited</span> (SIML) and its related companies “Sycamore Integrated Solutions
                                    Limited (SISL) “Party”, “Parties”, or “Us”, refers to both the Client and the
                                    Company, or either the Client or the Company.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Accuracy Of Information</h1>
                                <p>
                                    While the company attempts to ensure that the information on this Website ,platform
                                    and app is accurate, current, complete, fit for its intended purpose and compliant
                                    with the relevant Nigerian Legislation and regulations as at the time of access,
                                    this site and the online services are provided “as is”. Sycamore Investment and
                                    Asset Management Limited makes no representation or warranty, whether expressed or
                                    implied as to the accuracy, completeness or reliability of any information on this
                                    platform. All investable instruments are placed on this platform on a fiduciary
                                    basis and from public records. Sycamore makes no warranty whatsoever to you express
                                    or implied, regarding the security of the platform, the asset classes or any outcome
                                    of the investment tenure or results gotten due to market forces, force majeure and
                                    unforeseen events.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Confidentiality</h1>
                                <p>
                                    Information provided by you shall be kept confidential and not be used or disclosed
                                    in any manner incompatible with the purposes for which they are held.
                                    Notwithstanding, You acknowledge that we may disclose and transfer any information
                                    that you provide through this Website to (i) the Company, its affiliates, agents or
                                    information providers; or (ii) if we have a right or duty to disclose or are
                                    permitted or compelled to so disclose such information by law. You consent to the
                                    transmission, transfer or processing of such information to, or through, any country
                                    in the world, as we deem necessary or appropriate, and by using and providing
                                    information through this Website you agree to such transfers. Your use of the
                                    products and services on this Website may be monitored by the Company and the
                                    resultant information may be used by the Company for its internal business purposes
                                    or in accordance with the rules of any applicable regulatory or self-regulatory
                                    organization. Anyone accessing this platform expressly consents to such monitoring,
                                    tracking and recording.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Website content and materials</h1>
                                <p>
                                    You are permitted to store, display, analyse, modify, reformat, and print the
                                    information made available to you via these services for your own use only. You are
                                    by no means, permitted to publish, transmit, or otherwise reproduce this
                                    information, in whole or in part, in any format to any third party without the
                                    express written consent of Sycamore. In addition, you are not permitted to alter,
                                    obscure, or remove any copyright, trademark or any other notices that are provided
                                    to you in connection with the information contained on this Website. The Company
                                    reserves the right, at any time and from time to time, in the interests of its own
                                    editorial discretion and business judgement to add, modify, or remove any of the
                                    information without recourse to You. These Terms and Conditions are not intended to,
                                    and will not, transfer or grant any rights in or to the information other than those
                                    which are expressly described herein, and all rights not expressly granted herein
                                    are automatically reserved by the Company or any third party providers from whom the
                                    Company has obtained the information. You are advised to read and abide by any
                                    revised or additional terms and conditions that may be posted on this service from
                                    time to time concerning information generated by the Company or obtained from
                                    specific third party providers. Such third party providers shall have no liability
                                    to you for monetary damages on account of the information provided to you via this
                                    service.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">No warranties made as to security</h1>
                                <p>
                                    Sycamore makes no warranty whatsoever to you, express or implied, regarding the
                                    security of the platform, including with respect to the ability of unauthorised
                                    persons to intercept or access information transmitted by you through this service.
                                    Sycamore also makes no warranty or representation, whether express or implied, that
                                    the information or files available on this Website are free of viruses, destructive
                                    materials or any other data or code which is able to corrupt, compromise,
                                    jeopardise, disrupt, disable, harm or otherwise impede in any manner the operation
                                    of a computer system, computer network or your hardware or software. You accept all
                                    risks associated with the existence of such viruses, destructive materials or any
                                    other data or code which is able to corrupt, compromise, jeopardize, disrupt,
                                    disable, harm or otherwise impede in any manner the operation or content of a
                                    computer system, computer network or your hardware or software.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">No warranties; no responsibilities to update</h1>
                                <p>
                                    Sycamore doesn’t guarantee the quality or performance of this service in any way.
                                    The service is provided "as is," meaning you use it at your own risk. We don’t
                                    promise that the service will be correct, complete, reliable, or available. We are
                                    not responsible for maintaining or updating the data or services on this website.
                                    Neither Sycamore nor any of its third party providers shall have any responsibility
                                    to maintain the data and services made available on this Web site or to supply any
                                    corrections, updates, or releases in connection therewith. Availability of data and
                                    services are subject to change without notice.
                                </p>
                                <p>
                                    Please remember that past performance is not necessarily a guide to future
                                    performance, and that there can be no assurance that comparable results will be
                                    achieved. The value of units of securities and/or Premium Yield Investments and the
                                    income from them can go down as well as up and investors may not get back the amount
                                    originally invested. Exchange rate changes may cause the value of investments made
                                    by offshore investors to rise or fall. For further details on any of the products
                                    mentioned on this Website, please read the relevant offering documents or
                                    prospectus.
                                </p>
                                <p>
                                    Content not to be construed as a solicitation or recommendation Content on this
                                    Website is for informational purposes only without regard to any particular user’s
                                    investment objectives, financial situation, or means, and Sycamore is not soliciting
                                    any action based upon it. Information is not to be construed as a recommendation; or
                                    an offer to buy or sell; or the solicitation of an offer to buy or sell any
                                    security, financial product, or instrument; or to participate in any particular
                                    trading strategy in any jurisdiction in which such an offer or solicitation, or
                                    trading strategy would be illegal. Certain transactions give rise to substantial
                                    risk and are not suitable for all investors.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">No determination of suitability has been made; not all risks
                                    are disclosed; private advisors should be consulted</h1>
                                <p>
                                    The fact that “We” have made the data and services provided on this Website
                                    available to you constitutes neither a recommendation that You enter into a
                                    particular transaction nor a representation that any product described on this
                                    Website is suitable or appropriate for you. Many of the products described on this
                                    Website involve significant risks, and you should not enter into any transactions
                                    unless you have fully understood all such risks and have independently determined
                                    that such transactions are appropriate for you. Any discussion of the risks
                                    contained herein with respect to any product should not be considered to be a
                                    disclosure of all risks or complete discussion of the risks which are mentioned. You
                                    should not construe any of the material contained herein as business, financial,
                                    investment, hedging, trading, legal, regulatory, tax, or accounting advice nor make
                                    this service the primary basis for any investment decisions made by or on behalf of
                                    you, your accountants, or your managed or fiduciary accounts, and you may want to
                                    consult your business advisor, attorney, and tax and accounting advisors concerning
                                    any contemplated transactions.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Copyright notice</h1>
                                <p>Copyright and other relevant intellectual property rights exist on all text relating
                                    to the Company’s services and the full content of this website.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Potential disruption of service</h1>
                                <p>
                                    The Client shall be responsible for obtaining and maintaining all telephone,
                                    computer hardware, software, and other equipment needed to access and use this
                                    Website. Access to this platform may from time to time be unavailable, delayed,
                                    limited or slow due to, among other things:
                                </p>
                                <ol class="list-decimal pl-4 flex flex-col gap-1">
                                    <li>
                                        Hardware failure, including among other things, failures of computers (including
                                        your own computer), servers, networks, telecommunication lines and connections,
                                        and other electronic and mechanical equipment.
                                    </li>
                                    <li>
                                        Software failure, including among other things, bugs, errors, viruses,
                                        configuration problems, incompatibility of systems, utilities or applications,
                                        the operation of firewalls or screening programs, unreadable codes, or
                                        irregularities within particular documents or other content.
                                    </li>
                                    <li>Overload of system capacities.</li>
                                    <li>
                                        Damage caused by severe weather, earthquakes, wars, insurrection, riots,
                                        terrorism, civil commotion, act of God, accident, fire, water damage, explosion,
                                        mechanical breakdown or natural disasters.

                                    </li>
                                    <li>Interruption (whether partial or total) of power supplies or other utility of
                                        service.</li>
                                    <li>
                                        Strike or other stoppage (whether partial or total) of labour.
                                    </li>
                                    <li>
                                        Governmental or regulatory restrictions, exchange rulings, court or tribunal
                                        orders or other human intervention; or

                                    </li>
                                    <li>
                                        Any other cause (whether similar or dissimilar to any of the foregoing)
                                        whatsoever beyond our control.
                                    </li>
                                </ol>
                                <p>
                                    If access to this Website, platform or app is unavailable, delayed or limited or if
                                    this Website does not operate quickly and efficiently, you may be unable to transmit
                                    your instructions for transactions and other matters, or such instructions may not
                                    be promptly executed or you may be unable to retrieve information on a timely basis.
                                    If your operations are dependent on such communications with us, and such
                                    communications are disrupted or delayed, you may suffer losses. Sycamore shall not
                                    be liable for any such loss.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Links from this website</h1>
                                <p>This service may provide links to certain Internet sites (the “Sites”) sponsored and
                                    maintained by third parties. The Company is providing such links solely for
                                    convenience to You. Accordingly, Sycamore makes no representations concerning the
                                    content of the Sites. We do not monitor or review the content of other party’s Sites
                                    which are linked to from this website. Opinions expressed or materials appearing on
                                    such Sites do not constitute an endorsement by us and should not be regarded as the
                                    publisher of such opinions or materials. Please be aware that we are not responsible
                                    for the privacy practices, or content, of these sites. We encourage you to be aware
                                    when you leave our site & to read the privacy statements of these sites. You should
                                    evaluate the security and trustworthiness of any other site connected to this site
                                    or accessed through this site yourself, before disclosing any personal information
                                    to them. The Company will not accept any responsibility for any loss or damage in
                                    whatever manner, howsoever caused, resulting from your disclosure to third parties
                                    of personal information.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Limitation of liability</h1>
                                <p>
                                    Sycamore shall have no liability, contingent or otherwise, to You or to third
                                    parties, or any responsibility whatsoever, for the failure of any connection or
                                    communication service to provide or maintain your access to this service, or for any
                                    interruption or disruption of such access or any erroneous communication between the
                                    Company and You, regardless of whether the connection or communication service is
                                    provided by the Company or a third party service provider. We shall have no
                                    liability, contingent or otherwise, to You or to third parties, for the correctness,
                                    quality, accuracy, timeliness, reliability, performance, continued availability,
                                    completeness or delays, omissions, or interruptions in the delivery of the data and
                                    services available on this website or for any other aspect of the performance of
                                    this service or for any failure or delay in the execution of any transactions
                                    through this service. In no event shall the Company be liable for any special,
                                    indirect, incidental, or consequential damages which may be incurred or experienced
                                    on account of You using the data or services made available on this Website, even
                                    where the Company has been advised of the possibility of such damages. Sycamore
                                    shall have no responsibility to inform You of any difficulties experienced by the
                                    Company or third parties with respect to the use of the services or to take any
                                    action in connection therewith. We shall have no liability, contingent or otherwise,
                                    to You or to third parties, or any responsibility whatsoever, for the failure of any
                                    connection or communication service to provide or maintain your access to this
                                    service, or for any interruption or disruption of such access or any erroneous
                                    communication between the Company and You, regardless of whether the connection or
                                    communication service is provided by the Company or a third party service provider.
                                    The Company shall have no liability, contingent or otherwise, to You or to third
                                    parties, for the correctness, quality, accuracy, timeliness, reliability,
                                    performance, continued availability, completeness or delays, omissions, or
                                    interruptions in the delivery of the data and services available on this website or
                                    for any other aspect of the performance of this service or for any failure or delay
                                    in the execution of any transactions through this service. In no event shall the
                                    Company be liable for any special, indirect, incidental, or consequential damages
                                    which may be incurred or experienced on account of You using the data or services
                                    made available on this Website, even where the Company has been advised of the
                                    possibility of such damages. Sycamore shall have no responsibility to inform You of
                                    any difficulties experienced by the Company or third parties with respect to the use
                                    of the services or to take any action in connection therewith.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Governing law</h1>
                                <p>
                                    In the event any of the terms or provisions of these Terms and Conditions shall be held to be unenforceable, the remaining terms and provisions shall be unimpaired and the unenforceable term or provision shall be replaced by such enforceable term or provision as comes closest to the intention underlying the unenforceable term or provision. These Terms and Conditions shall be subject to any other agreements you have entered into with the Company. The user’s access to and use of the Website, and the terms of this disclaimer are governed by the laws of the Federal Republic of Nigeria without regards to the conflict of law provisions. You consent to the personal and exclusive jurisdiction of the courts located within Lagos State of Nigeria. All disputes arising shall be settled amicably between the parties. The parties agree to settle all disputes by the Lagos Muti-Door Courthouse (ADR) and its decision is final and binding on both parties. Each party settling its own cost.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">No waiver</h1>
                                <p>
                                    The Company’s failure to exercise or enforce any right or provision of the Terms of
                                    Service shall not constitute a waiver of such right or provision or prevent a
                                    subsequent enforcement of that or any other right or provision. No waiver of any of
                                    the provisions of this or any Agreement shall be effective unless it is expressly
                                    stated to be such and signed by both Parties.
                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <h1 class="font-semibold">Termination and notification of changes</h1>
                                <p>
                                    Sycamore may in its sole discretion terminate, or modify the contents of this
                                    platform with or without notice to you. The Company reserves the right to terminate,
                                    suspend and/or modify these conditions from time to time as it sees fit and your
                                    continued use of the site will signify your acceptance of any adjustment to these
                                    terms. You agree that Sycamore, its affiliates or subsidiaries shall not be liable
                                    to you in the event that it chooses to terminate, suspend or modify this Website or
                                    your use of this Website. This Web site is hereby issued and approved by Sycamore
                                    Investment and Asset Management Limited which is authorised and regulated by the
                                    Securities and Exchange Commission.

                                </p>
                            </div>

                            <div class="flex flex-col gap-3">
                                <p>©Sycamore Investment and Asset Management Limited 2025. </p>
                                <p>All rights reserved.</p>
                            </div>
                        </div>

                        <!-- Signature -->
                        <div class="mb-6 text-sm">
                            <p>Yours faithfully,</p>

                            <p class="font-semibold pt-4 pb-4">
                                For Sycamore Investment and Asset Management Limited
                            </p>

                            <div>
                                <img src="../../assets/signature/gbenga.png" class="w-32" alt="Authorised signature">
                                <div>
                                    <p class="pb-1">Gbenga Magbagbeola</p>
                                    <p>Managing Director </p>
                                </div>
                            </div>
                        </div>

                            <div v-if="investment.contract_status == 'accepted' || investment.contract_status == 'rejected'">
                                <p class="text-3xl font-Allura pb-0">
                                    {{ investment.Customer ? investment.Customer.name : ''}}
                                </p>
                                
                                <p class="">
                                    Contract {{ investment ? investment.contract_status : '' }}
                                </p>
                            </div>


                        <!-- Decide contract -->
                        <div class="mb-6" v-if="token && investment.contract_status == 'sent'">
                            <div class="buttons is-centered">
                                <button @click="handleDecideContract('accepted')"
                                    :class="loadingStatus1 ? 'is-loading' : ''"
                                    :disabled="loadingStatus1" class="button is-success is-small px-6">
                                    Accept
                                </button>
                                <button @click="handleDecideContract('rejected')"
                                    :class="loadingStatus2 ? 'is-loading' : ''"
                                    :disabled="loadingStatus2" class="button is-danger is-small px-6">
                                    Decline
                                </button>
                            </div>
                        </div>

                        <!-- footer -->
                        <hr>
                        <div class="text-center mt-4 pb-4 text-xs md:text-sm leading-6 font-semibold">
                            <p>The Board: Bade Aluko | Adeola Azeez | Oliver Nnona</p>
                            <p>
                                Executive Directors: Babatunde Akin-Moses | Onyinye Okonji | Mayowa Adeosun
                            </p>
                            <p v-if="contacts">
                                {{ contacts.address }} | assetmgt@sycamore.ng | {{
                                    contacts.customer_service_number }} | www.sycamore.ng
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab == 1">
                <TokenInvalid />
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Ripple from "@/components/Ripple";
import TokenInvalid from "@/components/TokenInvalid";
import { fetchInvestment, decidePremiumInvestmentContract } from "@/api/premium-investment";
import { getSycamoreContacts } from "@/api/contacts";

export default {
    name: 'PremiumInvestmentContract',
    components: {
        Ripple,
        TokenInvalid
    },

    data() {
        return {
            loadingStatus: false,
            loadingStatus1: false,
            loadingStatus2: false,
            investment: {},
            errorStatus: {},
            contacts: null,
            activeTab: 0,
            interest_payment_types: ["monthly", "quarterly", "daily", "weekly"]
        }
    },

    methods: {
        async getInvestment() {
            this.loadingStatus = true;

            try {
                const { offer_link } = this.$route.params
                const response = await fetchInvestment(offer_link)
                const data = response.data.data;
                if (data) {
                    this.investment = data;
                }
                this.activeTab = 0

            } catch (error) {
                this.activeTab = 1
                this.errorStatus = error.response.data

            } finally {
                this.loadingStatus = false;
            }
        },

        async handleDecideContract(status) {
            if (status == 'accepted') {
                this.loadingStatus1 = true;
            }

            if (status == 'rejected') {
                this.loadingStatus2 = true;
            }

            try {
                const response = await decidePremiumInvestmentContract({
                    premium_investment_id: this.investment.id,
                    status,
                    token: this.token
                })

                if (response.data.success) {
                    this.getInvestment();
                }

            } catch (err) {
                this.$buefy.notification.open({
                    message: err.response.data.message,
                    duration: 7000,
                    progressBar: true,
                    type: 'is-danger',
                    pauseOnHover: true
                })

            } finally {
                this.loadingStatus1 = false;
                this.loadingStatus2 = false;
            }
        },

        moment: function (date) {
            return moment(date);
        },

        async getContacts() {
            const response = await getSycamoreContacts();
            this.contacts = response.data.contact;

        }
    },

    mounted() {
        this.getInvestment();
        this.getContacts();
    },

    created() {
        const { token } = this.$route.query;
        this.token = token;
    }
}
</script>
